const { dataLayer } = require("../lib/analytics");

$(document).on("click", ".discover-more-button", () => {
  dataLayer.push({
    event: "discoverMoreClick",
  });
});
